module.exports = __webpack_public_path__ + "img/tebrikler-232.ca9e1ab9.png";